import axios from "axios";
import { API_URL } from "../config/config";
import { getHeaderOptions } from "./getHeaderOptions";

const API_ENDPOINT = API_URL + "api/v1/lead-distribution";

export interface DistributionRule {
  _id?: string;
  name?: string;
  integration?: string;
  ruleConfig?: {
    fieldName?: string;
    fieldValue?: string;
    custom?: Array<{
      integration?: string;
      key?: string;
      value?: string;
      operator?: string;
      users?: string[];
    }>;
  };
  recipientsIds?: {
    ids: { [userId: string]: { waitage: number; status: boolean } };
    cursor?: string;
    current_distribution?: string;
  };
  status?: boolean;
  createdBy?: string;
  totalDistributed?: number;
  totalNoOfRun?: number;
}

export interface DistributionConfig {
  recipientsIds?: {
    ids: { [userId: string]: { waitage: number; status: boolean } };
    cursor?: string;
    current_distribution?: string;
  };
  status?: boolean;
  configType?: string;
}

const getHeaders = () => ({
  ...getHeaderOptions,
  Authorization: localStorage.getItem("auth_token") || "",
});

export const getDistributionConfig = () => {
  return axios.get(`${API_ENDPOINT}/config`, { headers: getHeaders() });
};

export const updateDistributionConfig = (payload: DistributionConfig) => {
  return axios.post(`${API_ENDPOINT}/config`, payload, { headers: getHeaders() });
};

export const getDistributionRules = () => {
  return axios.get(`${API_ENDPOINT}/rule?orderBy=createdAt`, { headers: getHeaders() });
};

export const createDistributionRule = (rule: DistributionRule) => {
  return axios.post(`${API_ENDPOINT}/rule`, rule, { headers: getHeaders() });
};

export const updateDistributionRule = (rule: DistributionRule) => {
  const id = rule._id;
  const payload = { ...rule };
  delete payload._id;
  return axios.put(`${API_ENDPOINT}/rule/${id}`, payload, { headers: getHeaders() });
};

export const deleteDistributionRule = (ruleId: string) => {
  return axios.delete(`${API_ENDPOINT}/rule/${ruleId}`, { headers: getHeaders() });
};

export const getDistributionOptions = () => {
  return axios.get(`${API_ENDPOINT}/options-values`, { headers: getHeaders() });
};